import { StyledEngineProvider } from "@mui/material";
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from './App';
import "./i18n/config";
import './index.css';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { store } from "./store/store";
var root = ReactDOM.createRoot(document.getElementById('root'));
var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
// Set viewport properties based on the device OS
var viewportContent = isIOS ? 'width=device-width, initial-scale=1, maximum-scale=1' : 'width=device-width, initial-scale=1, shrink-to-fit=no';
// Create a meta tag and append it to the document head
var metaTag = document.createElement('meta');
metaTag.name = 'viewport';
metaTag.content = viewportContent;
document.head.appendChild(metaTag);
if (process.env.NODE_ENV !== "development") {
    console.log = function () { };
    console.debug = function () { };
    console.info = function () { };
    console.warn = function () { };
}
root.render(/*#__PURE__*/ React.createElement(Provider, {
    store: store
}, /*#__PURE__*/ React.createElement(BrowserRouter, null, /*#__PURE__*/ React.createElement(StyledEngineProvider, {
    injectFirst: true
}, /*#__PURE__*/ React.createElement(App, null)))));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
